import { render, staticRenderFns } from "./DHWEnergy.vue?vue&type=template&id=c8d89670&scoped=true"
import script from "./DHWEnergy.vue?vue&type=script&lang=js"
export * from "./DHWEnergy.vue?vue&type=script&lang=js"
import style0 from "./DHWEnergy.vue?vue&type=style&index=0&id=c8d89670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d89670",
  null
  
)

export default component.exports